export const statuses = {
    draft: 'Draft',
    published: 'Published',
}
